import React from "react";
import {Button, Col, Row} from "react-bootstrap"

import BreadcrumbObject from "../../../js/breadcrumb"

import "bootstrap/dist/css/bootstrap.min.css";
import "../../../css/main.css";
import {trackPromise} from "react-promise-tracker";
import {TrainRequest} from "../../../js/request/trainRequest"
import {ModalBase, ModalLectureApply, ModalCourseInfo, ModalSureSend} from "../../../js/modal"
import {Paging} from "../../../js/pagination"

class Lecture extends React.Component {
    errorPage = "lecture"
    errorId = "lectureErrorInfo"
    type = 1;
    pageTotal = 0
    status = [{
        title: "招生中",
        className: "sureStartClass"
    }, {
        title: "確定開課",
        className: "enrollingBack"
    }, {
        title: "報名結束",
        className: "crossDeadLine"
    }]

    constructor(props) {
        super(props);
        this.state = {
            "isLogin": !!localStorage.getItem("token"),
            "isAdmin": localStorage.getItem("identity") === "admin",
            "contentNo": [],
            "pageName": "職安衛訓練",
            "pageTotal": this.pageTotal,
            "nowPage": 1,
            "showlectureInfo": false,
            "showApply": false,
            "showInfo": false,
            "sureSend": false,
            "infoMessage": "",
            "lectureItem": {},
            "applyItem": {},
            "safetyMemo": []
        }
    }

    componentDidMount = () => {
        trackPromise(
            TrainRequest.getSize({"type": this.type})
                .then(response => {
                    this.pageTotal = Math.ceil(response.data.size / 12)
                    this.setState({"pageTotal": this.pageTotal})
                    this.getCourse(1);
                })
        )
    }

    getCourse = (now) => {
        trackPromise(
            TrainRequest.searchList({
                "type": this.type,
                "size": 12,
                "page": now
            }).then(response => {
                this.setState({"contentNo": response.data})
            })
        )
    }

    pageChange = (now) => {
        this.setState({"nowPage": now})
        this.getCourse(now)
    }

    getDetail = (no) => {
        trackPromise(
            TrainRequest.getDetail(no)
                .then(response => {
                    let lectureItem = response.data
                    this.getMemo(response.data.templateId)
                    this.setState({"lectureItem": lectureItem})
                    document.getElementById("lectureInfo").innerHTML = response.data.content.replace(/\n/g, "<br />");
                })
        )
    }

    getMemo = (templateId) => {
        trackPromise(
            TrainRequest.getOSFMemo(templateId)
                .then(response => {
                    this.setState({"safetyMemo": response.data.courseMemoArray})
                })
        )
    }

    showDetail = (show, no) => {
        if (!this.state.showlectureInfo) {
            this.getDetail(no)
        }
        this.setState({"showlectureInfo": show})
    }

    showApply = (show, no) => {
        if (this.state.showlectureInfo) {
            this.setState({"showlectureInfo": false})
        }
        if (!this.state.showApply) {
            this.getDetail(no)
        }
        this.setState({"showApply": show})
    }


    sureSend = () => {
        this.setState({"sureSend": !this.state.sureSend})
    }

    showInfo = (message) => {
        this.setState({"showInfo": !this.state.showInfo})
        this.setState({"infoMessage": message});
    }

    redirectTo = (aim) => {
        const path = `${window.location.href}/${aim}`
        window.location.href = path;
    }

    signUp = () => {
        const educationElement = document.getElementById("education");
        const requestData = {
            "courseId": this.state.lectureItem.id,
            "memberId": document.getElementById("memberId").value,
            "companyName": document.getElementById("companyName") ? document.getElementById("companyName").value : null,
            "name": document.getElementById("name").value,
            "email": document.getElementById("email").value,
            "cellPhone": document.getElementById("cellPhone").value,
            "phone": document.getElementById("phone").value,
            "faxNumber": document.getElementById("faxNumber").value,
            "address": document.getElementById("address").value,
            "memo": document.getElementById("memo").value,
            "birthday": document.getElementById("birthday") ? document.getElementById("birthday").value : null,
            "identity": document.getElementById("identity") ? document.getElementById("identity").value : null,
            "education": educationElement ? educationElement.options[educationElement.selectedIndex].value : null,
            "graduatedSchool": document.getElementById("graduatedSchool") ? document.getElementById("graduatedSchool").value : null,
            "certificateOfCompletionNumber": document.getElementById("certificateOfCompletionNumber") ? document.getElementById("certificateOfCompletionNumber").value : null,
            "serviceUnit": document.getElementById("serviceUnit") ? document.getElementById("serviceUnit").value : null,
            "residenceAddress": document.getElementById("residenceAddress").value,
            "contactName": document.getElementById("contactName").value,
        }

        let reuqestMethod = "";
        let info = "";
        if (!requestData.name) {
            info = "請輸入學員姓名";
        } else if (!requestData.email) {
            info = "請輸入電子信箱";
        } else if (!requestData.cellPhone) {
            info = "請輸入手機號碼";
        } else if (!requestData.phone) {
            info = "請輸入電話號碼";
        } else if (!requestData.address) {
            info = "請輸入聯絡地址";
        } else if (!requestData.birthday) {
            info = "請輸入生日";
        } else if (!requestData.identity) {
            info = "請輸入身分證字號";
        } else if (!requestData.education) {
            info = "請輸入學歷";
        } else if (!requestData.graduatedSchool) {
            info = "請輸入畢業學校";
        } else if (!requestData.serviceUnit) {
            info = "請輸入服務單位";
        } else if (!requestData.residenceAddress) {
            info = "請輸入戶籍地址";
        } else if (!requestData.contactName) {
            info = "請輸入聯絡人姓名";
        } else {
            reuqestMethod = TrainRequest.createSignUpSafetyHealth;
        }

        if (reuqestMethod) {
            trackPromise(
                reuqestMethod(requestData)
                    .then(response => {
                        this.setState({"sureSend": !this.state.sureSend})
                        this.showInfo("新增成功")
                        window.location.reload();
                    })
                    .catch(error => {
                        this.setState({"sureSend": !this.state.sureSend})
                        this.showInfo("新增失敗")
                        document.getElementById(this.errorId).innerHTML = error.message
                        console.log(error.message)
                    })
            )
        } else {
            this.showInfo(info);
            this.setState({"sureSend": !this.state.sureSend})
        }

    }

    render() {
        return (
            <div className="lecture">
                {this.state.isLogin && this.state.isAdmin ?
                    <Row className="controlButtons">
                        <Col xs={"auto"}>
                            <Button className="edit kanEdit editBlue" onClick={() => {
                                this.redirectTo("maintain")
                            }}>課程維護</Button>
                        </Col>
                        <Col xs={"auto"}>
                            <Button className="edit kanEdit editBlue" onClick={() => {
                                this.redirectTo("SignUpList")
                            }}>報名列表</Button>
                        </Col>
                        <Col xs={"auto"}>
                            <Button className="edit kanEdit" variant="success" onClick={() => {
                                this.redirectTo("create")
                            }}>新增課程</Button>
                        </Col>
                    </Row> : <></>}
                <BreadcrumbObject secondTitle={"教育訓練"} thirdTitle={"職安衛課程"}/>
                <div className="subLabel">
                    <Row noGutters={true}>
                        <Col xs={3}/>
                        <Col className="lectureName">課程名稱</Col>
                        <Col xs={3} sm={2} className="hiddenDate">上課日期</Col>
                        <Col xs={3} sm={2}/>
                    </Row>
                </div>
                <hr/>
                <div className="content">
                    {this.state.contentNo.map((item, index) => {
                        return (
                            <div className="contentItem" key={index}>
                                <Row noGutters={true} className="align-items-center">
                                    <Col className='lectureNo' xs={1}>
                                        <div>{index + 1 + 12 * (this.state.nowPage - 1)}</div>
                                    </Col>
                                    <Col xs={2}>
                                        <span className={this.status[item.status].className}>
                                            {this.status[item.status].title}
                                        </span>
                                    </Col>
                                    <Col className="lectureName">
                                        <div onClick={() => {
                                            this.showDetail(true, item.id)
                                        }} className="ellipsis">{item.name}</div>
                                    </Col>
                                    <Col xs={3} sm={2} className="hiddenDate">{item.startClassTime}</Col>
                                    <Col xs={3} sm={2}>
                                        <Row>
                                            <Col><Button onClick={() => {
                                                this.showDetail(true, item.id)
                                            }} className="edit editBlue osfButton">課程資訊</Button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col><Button onClick={() => {
                                                this.showApply(true, item.id)
                                            }} className="edit" variant="success osfButton">我要報名</Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        )
                    })}
                </div>
                <Paging pageTotal={this.state.pageTotal} pageChange={this.pageChange}
                        nowPage={this.state.nowPage}/>
                <ModalLectureApply show={this.state.showApply}
                                   lectureItem={this.state.lectureItem}
                                   close={() => {
                                       this.showApply()
                                   }}
                                   ok={() => {
                                       this.sureSend()
                                   }}
                                   type={this.type}/>
                <ModalSureSend show={this.state.sureSend}
                               close={() => {
                                   this.sureSend()
                               }}
                               ok={() => {
                                   this.signUp()
                               }}
                               message={"確認送出"}/>
                <ModalCourseInfo show={this.state.showlectureInfo}
                                 close={() => {
                                     this.showDetail()
                                 }}
                                 lectureItem={this.state.lectureItem}
                                 safetyMemo={this.state.safetyMemo}
                                 type={this.type}
                                 hasApply="true"
                                 showApply={() => this.showApply(this.state.lectureItem.id, this.type)}/>
                <ModalBase show={this.state.showInfo}
                           close={() => {
                               this.showInfo()
                           }}
                           message={this.state.infoMessage}
                           ok={() => {
                               this.showInfo()
                           }}
                           error={this.errorPage}/>
            </div>
        );
    }
}


export const osf = {
    routeProps: {
        path: "/Education-And-Train/Occupational-Safety-And-Health",
        component: Lecture
    },
    name: "職安衛課程"
}



